import { JSX } from 'react';
import { SizesProvider } from '@/state/sizesProvider';

// components
import { OrFeaturedVideo } from './or-featured-video';

// helpers
import { parseImageFromCMS } from '@/lib/contentstack-sdk/utils/parseHelpers';
import { IOrFeaturedVideoCsProps } from './or-featured-video.types';

// types
export const OrFeaturedVideoCS = ({
  block,
}: IOrFeaturedVideoCsProps): JSX.Element | undefined => {
  const {
    _content_type_uid: contentType,
    description,
    video_url,
    video_thumbnail,
    video_button_aria_label,
    video_title,
    bottom_spacing,
    top_spacing,
  } = block;
  return (
    <SizesProvider contentType={contentType}>
      <OrFeaturedVideo
        description={description}
        thumbnail={parseImageFromCMS(video_thumbnail)}
        playButtonAriaLabel={video_button_aria_label}
        title={video_title}
        url={video_url}
        bottomSpacing={bottom_spacing}
        topSpacing={top_spacing}
      />
    </SizesProvider>
  );
};
